import styled from "styled-components";

import { rankingMobileBreakpoint } from "pages/[tenant]/g/[group_slug]/ranking/utils/breakpoint";

export const RankingPageContainer = styled.div`
  max-width: 56.25rem; // 900px
  margin: 0 auto;
  padding: 0 1rem;

  margin-top: 9.5rem;
  padding: 0 1rem;

  height: 100%;

  @media (max-width: ${rankingMobileBreakpoint}px) {
    margin-bottom: 0rem;
    margin-top: 4rem;
  }
`;
